import { default as indexngZcxIDz9kMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue?macro=true";
import { default as _91id_93D1g9l5ZY2DMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue?macro=true";
import { default as _91hash_93jCgju1seVNMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue?macro=true";
import { default as waiting_45shippingAVRiRRduvDMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue?macro=true";
import { default as waiting0bWFsqIhfXMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue?macro=true";
import { default as component_45stublb9fWgCUSAMeta } from "/var/www/releases/aartedainfluencia-20260802-201559/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stublb9fWgCUSA } from "/var/www/releases/aartedainfluencia-20260802-201559/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue")
  },
  {
    name: "index___pt-BR___default",
    path: "/",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue")
  },
  {
    name: "index___pt-BR",
    path: "/pt-BR",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue")
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/index.vue")
  },
  {
    name: "order-id___en",
    path: "/en/order/:id()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue")
  },
  {
    name: "order-id___pt-BR___default",
    path: "/order/:id()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue")
  },
  {
    name: "order-id___pt-BR",
    path: "/pt-BR/order/:id()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue")
  },
  {
    name: "order-id___it",
    path: "/it/order/:id()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue")
  },
  {
    name: "order-id___zh-CN",
    path: "/zh-CN/order/:id()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/order/[id].vue")
  },
  {
    name: "thank-you-hash___en",
    path: "/en/thank-you/:hash()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue")
  },
  {
    name: "thank-you-hash___pt-BR___default",
    path: "/thank-you/:hash()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue")
  },
  {
    name: "thank-you-hash___pt-BR",
    path: "/pt-BR/thank-you/:hash()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue")
  },
  {
    name: "thank-you-hash___it",
    path: "/it/thank-you/:hash()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue")
  },
  {
    name: "thank-you-hash___zh-CN",
    path: "/zh-CN/thank-you/:hash()",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/thank-you/[hash].vue")
  },
  {
    name: "waiting-shipping___en",
    path: "/en/waiting-shipping",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue")
  },
  {
    name: "waiting-shipping___pt-BR___default",
    path: "/waiting-shipping",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue")
  },
  {
    name: "waiting-shipping___pt-BR",
    path: "/pt-BR/waiting-shipping",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue")
  },
  {
    name: "waiting-shipping___it",
    path: "/it/waiting-shipping",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue")
  },
  {
    name: "waiting-shipping___zh-CN",
    path: "/zh-CN/waiting-shipping",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting-shipping.vue")
  },
  {
    name: "waiting___en",
    path: "/en/waiting",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue")
  },
  {
    name: "waiting___pt-BR___default",
    path: "/waiting",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue")
  },
  {
    name: "waiting___pt-BR",
    path: "/pt-BR/waiting",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue")
  },
  {
    name: "waiting___it",
    path: "/it/waiting",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue")
  },
  {
    name: "waiting___zh-CN",
    path: "/zh-CN/waiting",
    component: () => import("/var/www/releases/aartedainfluencia-20260802-201559/pages/waiting.vue")
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stublb9fWgCUSA
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stublb9fWgCUSA
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/en-sitemap.xml",
    component: component_45stublb9fWgCUSA
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/pt-br-sitemap.xml",
    component: component_45stublb9fWgCUSA
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/it-sitemap.xml",
    component: component_45stublb9fWgCUSA
  },
  {
    name: component_45stublb9fWgCUSAMeta?.name,
    path: "/zh-cn-sitemap.xml",
    component: component_45stublb9fWgCUSA
  }
]